import React from 'react'
import { ProgressBar } from 'primereact/progressbar'
import './progressBarCom.scss'

const ProgressBarComp = ({ value, ...props }) => {
  const parseTwoDecimal = parseFloat(value).toFixed(2)

  return <ProgressBar value={parseTwoDecimal} {...props} />
}

export default ProgressBarComp
